export const FETCHING_USAGE_LOGS = "FETCHING.USAGE_LOGS";
export const DELETING_USAGE_LOG = "DELETING.USAGE_LOG";
export const FETCHED_USAGE_LOGS = "FETCHED.USAGE_LOGS";
export const ERROR_FETCHING_USAGE_LOGS = "ERROR.FETCHING_USAGE_LOGS";
export const ADDING_USAGE_LOG = "ADDING.USAGE_LOG";
export const ADDED_USAGE_LOG = "ADDED.USAGE_LOG";
export const DELETED_USAGE_LOG = "DELETED.USAGE_LOG";
export const ERROR_ADD_USAGE_LOG = "ERROR.ADD.USAGE_LOGS";
export const ERROR_DELETING_USAGE_LOG = "ERROR.DELETING.USAGE_LOG";